module.exports = __webpack_public_path__ + "img/BENI.7193b682.png";